module.exports = __webpack_public_path__ + "static/A2P StSimeon_HMatte.e4fe05e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/A2P StSimeon_HMatte.jpg
// module id = 854
// module chunks = 14663744061042